import React from 'react'
import { Link } from 'react-router-dom'

function AccessDenied() {
    return (
        <div className="center_screen" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '40px 20px'
        }}>
            <img 
                src="/images/no_access.png" 
                alt="Access Denied" 
                style={{
                    height: '250px',
                    width: 'auto',
                    maxWidth: '250px'
                }}
            />
            <h4 style={{
                color: "#666",
                marginTop: '20px',
                fontSize: '24px',
                fontWeight: '600',
                textAlign: 'center',
                maxWidth: '600px',
                lineHeight: '1.5'
            }}>
                You don't have access to the requested page. Kindly contact the admin if you feel like you need to have this permission.
            </h4>
            <Link 
                to="/dashboard" 
                style={{
                    marginTop: '30px',
                    padding: '12px 24px',
                    backgroundColor: '#2196f3',
                    color: '#fff',
                    textDecoration: 'none',
                    borderRadius: '6px',
                    fontWeight: '500',
                    transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#1976d2';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#2196f3';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                Go to Dashboard
            </Link>
        </div>
    )
}

export default AccessDenied
